import { AsyncPipe, NgClass, isPlatformBrowser } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    Input,
    OnChanges,
    OnInit,
    PLATFORM_ID,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { Observable, ReplaySubject, from } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { IntersectionObserverDirective } from '../../../../shared/intersection-observer/intersection-observer.directive';
import { LoaderComponent } from '../../../../shared/loader/loader.component';

@Component({
    selector: 'app-manual-video',
    templateUrl: './manual-video.component.html',
    imports: [
        IntersectionObserverDirective,
        NgClass,
        LoaderComponent,
        FontAwesomeModule,
        AsyncPipe,
    ],
})
export class ManualVideoComponent implements OnInit, OnChanges {
    @Input() additionalClasses: string[] = [];
    @Input() additionalVideoClasses: string[] = [];
    @Input() bufferingClasses: Observable<string[]>;
    @Input() showBuffering: boolean = true;
    @Input() poster: string;
    @Input() mp4src: string;
    @Input() preload: boolean = false;

    playing = false;
    loaded = false;
    started = false;
    buffering = new ReplaySubject<boolean>(1);
    @ViewChild('video', { static: true }) private video: ElementRef;

    faPlay = faPlay;
    faPause = faPause;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.bufferingClasses = this.buffering.pipe(
            startWith(false),
            map(value => {
                return [value ? 'opacity-25' : 'opacity-0'].concat(
                    this.additionalVideoClasses
                );
            })
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.preload && changes.preload.currentValue) {
            this.preloadVideo();
        }
    }

    preloadVideo(force = false) {
        console.log('preload');
        this.video.nativeElement.preload = 'metadata';
        if (
            force === true &&
            isPlatformBrowser(this.platformId) &&
            !this.loaded &&
            // @ts-ignore
            !navigator.connection?.saveData
        ) {
            this.video.nativeElement.load();
            this.loaded = true;
        }
    }

    requestPlay() {
        from(this.video.nativeElement.play()).subscribe(() => {
            this.playing = true;
            this.started = true;
            this.cd.detectChanges();
        });
    }

    requestPause() {
        if (this.playing === true) {
            this.video.nativeElement.pause();
            this.playing = false;
        }
    }

    togglePlayPause() {
        if (this.playing) {
            this.requestPause();
        } else {
            this.requestPlay();
        }
    }

    videoEnded() {
        this.video.nativeElement.currentTime = 0;
        this.playing = false;
        this.started = false;
    }

    onVisibilityChange(visible: boolean) {
        if (visible === true) {
            this.preloadVideo(true);
        }
    }
}
